'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './proxy-holder-select.routes';

export class ProxyHolderSelectComponent {
  constructor(Auth, DTOptionsBuilder, dialogs, $uibModal, $window, $stateParams, VotingsService, $state, User,
              SettingsService, PropertyService, VoterGroupsService) {
    'ngInject';

    this.$state = $state;

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.ballotId;

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.useSuite = settings.data.useSuite;

      VotingsService.get({id: this.voteId}, vote => {
        this.vote = vote;
        this.ballot = this.vote.ballots.find(ballot => ballot._id = this.ballotId);

        let VG_DATA_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
        VoterGroupsService[VG_DATA_METHOD]({id: this.vote.voterGroup._id}, vg => {

          this.properties = vg.properties;

          this.proxyHolders = [];

          let proxies = this.vote.proxies.filter(o => o.proxy.enabled);
          let ballotVotes = this.vote.votes.filter(vote => vote.ballot == this.ballotId);

          let holderMap = {};

          proxies.forEach(o => {

            let alreadyVotedFor = !!ballotVotes.find(vote => vote.property == o.property);
            if (alreadyVotedFor)
              return;

            let PROXY_NAME = null;

            if (o.proxy.type === "default") {
              PROXY_NAME = this.vote.defaultProxy.name;
            } else if (o.proxy.type === "write-in" && o.proxy.writeInProxyName && o.proxy.writeInProxyApproved) {
              PROXY_NAME = o.proxy.writeInProxyName;
            } else {
              return;
            }

            if (!holderMap[PROXY_NAME]) {
              holderMap[PROXY_NAME] = [];
            }

            let property = this.properties.find(ppty => ppty._id == o.property);

            if (property) {
              holderMap[PROXY_NAME].push(property);
            }
          });

          Object.keys(holderMap).forEach(proxyHolder => {
            if (holderMap[proxyHolder].length) { // at least one property
              this.proxyHolders.push({
                name: proxyHolder,
                addressesCount: holderMap[proxyHolder].length,
                properties: holderMap[proxyHolder]
              })
            }

          })


        }, err => {
          console.log("Could not retrieve vote.")
        });

      }, err => {
        console.log("Could not retrieve users.")
      });

    });

    this.back = _ => $window.history.back();
  }

  castVote(proxy) {
    this.$state.go('cast-vote-proxy',{id: this.ballotId, voteId: this.voteId, properties: proxy.properties, proxyName: proxy.name});
  }

}

export default angular.module('conduu.proxyHolderSelect', [uiRouter])
  .config(routes)
  .component('proxyHolderSelect', {
    template: require('./proxy-holder-select.html'),
    controller: ProxyHolderSelectComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/proxy-holder-select/proxy-holder-select.component.js